import React, { useState, useRef, useEffect } from "react";
import "../../assets/css/menu.css"
import "../../assets/css/responsive.css";
// import MobileHeader from "./MobileHedaer";
// import menimg from '../../assets/images/megamenu-banner7.jpg';
import floorcovring001 from '../../assets/images/floorcovring001.jpg';
import bathlinen001 from '../../assets/images/bathlinen001.jpg';
import Homeaccessories001 from '../../assets/images/Homeaccessories001.jpg';
import { Link } from "react-router-dom";
import Button from 'react-bootstrap/Button';

function Navigation() {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Toggle dropdown open/close
  const handleToggle = () => {
    setIsOpen((prev) => !prev);
  };

  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <header className="header animated d-flex align-items-center header-1">
        <div className="container">
          <div className="row">
            {/*Mobile Icons*/}
            <div className="col-4 col-sm-4 col-md-4 d-block d-lg-none mobile-icons">
              {/*Mobile Toggle*/}
            </div>
            {/*Mobile Icons*/}
            {/*Desktop Logo*/}
            <div className="logo col-4 col-sm-4 col-md-4 col-lg-2 align-self-center">
              <Link to="/">
                <img
                  src="images/avon-logo.svg"
                  alt="logo"
                  title="logo"
                />
              </Link>
            </div>
            {/*End Desktop Logo*/}
            <div className="col-1 col-sm-1 col-md-1 col-lg-8 align-self-center d-menu-col">
              {/*Desktop Menu*/}
              <nav className="grid__item" id="AccessibleNav">
                <ul id="siteNav" className="site-nav medium center hidearrow">
                  <li className="lvl1 parent megamenu">
                   <Link to="/productList">
                         Floor Covering <i className="anm anm-angle-down-l" />
                    </Link>
                    <div className="megamenu style4 row row-cols-2 row-cols-sm-2 row-cols-md-3 row-cols-lg-5">
                      <div className="col-md-3"> 
                      <ul className="subLinks" style={{ marginTop:"5px" }}>
                      <li className="lvl-2 parent">
                        <Link to="#" className="site-nav lvl-2">
                           Bath Mat 
                          <span style={{ fontSize:"10px", position:"absolute", right:"0px", top:"5px"}}> <i className="bi bi-chevron-right"></i> </span>
                        </Link>

                        {/* Sub Dropdown for Bath Mat */}

                        <ul className="subDropdown">
                          <li><Link to="/productList"> Cotton Bath Mat </Link> </li>
                          <li><Link to="/productList"> Microfiber Bath Mat </Link> </li>
                          <li><Link to="/productList"> Rubber Bath Mat </Link> </li>
                        </ul>
                      </li>

                      <li className="lvl-2 parent">
                        <Link to="/productList" className="site-nav lvl-2">
                           Shower Mat
                        </Link>

                        {/*-------Sub Dropdown for Bath Mat ------*/}

                        <ul className="subDropdown">
                          <li><Link to="/productList"> Cotton Bath Mat </Link></li>
                          <li><Link to="/productList"> Microfiber Bath Mat </Link></li>
                          <li><Link to="/productList"> Rubber Bath Mat </Link></li>
                        </ul>
                      </li>
                    </ul>
                 </div>
                 <div className="col-md-3"> 
                         <ul className="subLinks" style={{ marginTop:"5px"}}>
                             <li className="lvl-2">  <Link to="/productList" className="site-nav lvl-2" >  Outdoor Mat </Link> </li>
                             <li className="lvl-2">  <Link to="/productList" className="site-nav lvl-2" >  Kitchen Mat </Link> </li>
                          </ul>
                      </div>
                      <div className="col-md-3"> 
                         <ul className="subLinks" style={{ marginTop:"5px"}}>
                             <li className="lvl-2">  <Link to="/productList" className="site-nav lvl-2" >  Floor Mat </Link> </li>
                             <li className="lvl-2">  <Link to="/productList" className="site-nav lvl-2" >  Carpet & Rug </Link> </li>
                          </ul>
                      </div>

                       <div className="col-md-3"> 
                         <ul className="subLinks" style={{ marginTop:"5px"}}>
                           <li className="lvl-2">  <Link to="/productList" className="site-nav lvl-2" > Yoga Mat </Link> </li>
                          </ul>
                      </div>

                       <div className="col-md-3"> 
                         <Link to="/productList">
                           <img src={floorcovring001} alt="megamenu banner" style={{ marginTop: "2px", border:"1px solid #c1bfbfff",
                             padding:"2px", maxWidth:"100%", Display:"block", height:"auto"}} />
                         </Link>
                      </div>
                    </div>
                  </li>

                  <li className="lvl1 parent dropdown subLinks">
                        <Link to="/tablewear">
                           TableWear <i className="anm anm-angle-down-l" />
                        </Link>
                      <ul className="dropdown">
                               {/* Parent Item with SubDropdown */}
                            <li className="parent">
                              <Link to="#" className="site-nav">
                                Table Mat  <span style={{ fontSize:"10px", position:"absolute", right:"0px", top:"12px"}}> <i className="bi bi-chevron-right"></i> </span>
                              </Link>

                              {/* Sub Dropdown for Table Mat */}
                              <ul className="subDropdown">
                                <li><Link to="/productList"> Cotton Table Mat </Link></li>
                                <li><Link to="/productList"> PVC Table Mat </Link></li>
                                <li><Link to="/productList"> Woven Table Mat </Link></li>
                              </ul>
                            </li>

                          <li className="parent">
                              <Link to="/tablewear" className="site-nav"> Table Runner </Link>
                                <ul className="subDropdown">
                                <li><Link to="/productList"> Cotton Table Mat</Link></li>
                                <li><Link to="/productList"> PVC Table Mat</Link></li>
                                <li><Link to="/productList"> Woven Table Mat</Link></li>
                              </ul>
                            </li>
                          <li><Link to="/tablewear" className="site-nav"> Table Cover</Link></li>
                          <li><Link to="/tablewear" className="site-nav"> Table Accessories</Link></li>
                        </ul>
                    </li>

                  <li className="lvl1 parent megamenu">
                    <Link to="/bathline">
                       Bath Linen <i className="anm anm-angle-down-l" />
                    </Link>
                    <div className="megamenu style4 row row row-cols-2 row-cols-sm-2 row-cols-md-3 row-cols-lg-5">
                      <div className="col-md-3"> 
                         <ul className="subLinks" style={{ marginTop:"5px"}}>
                          <li className="lvl-2">  <Link to="/bathline" className="site-nav lvl-2" > Bath Towel </Link> </li>
                          <li className="lvl-2">  <Link to="/bathline" className="site-nav lvl-2" > Medium Towel </Link> </li>
                          </ul>
                      </div>
                      <div className="col-md-3"> 
                         <ul className="subLinks" style={{ marginTop:"5px"}}>
                          <li className="lvl-2">  <Link to="/bathline" className="site-nav lvl-2" > Hand Towel </Link> </li>
                           <li className="lvl-2">  <Link to="/bathline" className="site-nav lvl-2" > Face Towel </Link> </li>
                          </ul>
                      </div>
                      <div className="col-md-3"> 
                            <ul className="subLinks" style={{ marginTop:"5px"}}>
                               <li className="lvl-2">  <Link to="/bathline" className="site-nav lvl-2" >  Wash Basin Towel </Link> </li>
                               <li className="lvl-2">  <Link to="/bathline" className="site-nav lvl-2" > Bath Gown </Link> </li>
                          </ul>
                      </div>
                       <div className="col-md-3"> 
                         <ul className="subLinks" style={{ marginTop:"5px"}}>
                               <li className="lvl-2">  <Link to="/bathline" className="site-nav lvl-2" >  Towel Sets </Link> </li>
                               <li className="lvl-2">  <Link to="/bathline" className="site-nav lvl-2" >  Kids Towel </Link> </li>
                          </ul>
                      </div>
                       <div className="col-md-3"> 
                         <Link to="/productList">
                           <img src={bathlinen001} alt="megamenu banner" style={{ marginTop: "2px", border:"1px solid #c1bfbfff", padding:"2px", maxWidth:"100%", Display:"block", height:"auto"}} />
                         </Link>
                      </div>
                    </div>
                  </li>

                  <li className="lvl1 parent dropdown">
                    <Link to="#">
                        Bed Linen <i className="anm anm-angle-down-l" />
                    </Link>
                    <ul className="dropdown">
                      <li>
                        <Link to="blog-left-sidebar.html" className="site-nav">
                            Bed Sheet
                        </Link>
                      </li>
                      <li>
                        <Link to="blog-right-sidebar.html" className="site-nav">
                          Bed Covers
                        </Link>
                      </li>
                      <li>
                        <Link to="blog-fullwidth.html" className="site-nav">
                            Dohar 
                        </Link>
                      </li>
                      <li>
                        <Link to="blog-2columns.html" className="site-nav">
                           Comforter
                        </Link>
                      </li>
                      <li>
                        <Link to="blog-3columns.html" className="site-nav">
                             Bed in a Bag
                        </Link>
                      </li>
                      <li>
                        <Link to="blog-4columns.html" className="site-nav">
                            Pillows
                        </Link>
                      </li>
                    </ul>
                  </li>

                  <li className="lvl1 parent dropdown">
                    <Link to="/homedecor">
                         Home Decor
                    </Link>
                    <ul className="dropdown">
                      <li>
                        <Link to="/homedecor" className="site-nav">
                          Diwan Sets
                        </Link>
                      </li>
                      <li>
                        <Link to="/homedecor" className="site-nav">
                           Fancy Cushion and Bolster
                        </Link>
                      </li>
                      <li>
                        <Link to="/homedecor" className="site-nav">
                            Cushion And Bolster Covers
                        </Link>
                      </li>
                      <li>
                        <Link to="/homedecor" className="site-nav">
                           Throws
                        </Link>
                      </li>
                      <li>
                        <Link to="/homedecor" className="site-nav">
                           Sofa Cover
                        </Link>
                      </li>
                      <li>
                        <Link to="/homedecor" className="site-nav">
                           Sofa Seatback
                        </Link>
                      </li>
                      <li>
                        <Link to="/homedecor" className="site-nav">
                            Sofa Panel
                        </Link>
                      </li>
                    </ul>
                  </li>

                  <li className="lvl1 parent megamenu">
                    <Link to="/dustbin">
                       Home Accessories <i className="anm anm-angle-down-l" />
                    </Link>
                      <div className="megamenu style4 row row-cols-2 row-cols-sm-2 row-cols-md-3 row-cols-lg-5">
                      
                      <div className="col-md-3"> 
                         <ul className="subLinks" style={{ marginTop:"5px"}}>
                          <li className="lvl-2">  <Link to="/dustbin" className="site-nav lvl-2" >  Dustbin </Link> </li>
                          <li className="lvl-2">  <Link to="/dustbin" className="site-nav lvl-2" >  Laundry basket </Link> </li>
                           <li className="lvl-2">  <Link to="/dustbin" className="site-nav lvl-2" > Trays </Link> </li>
                           <li className="lvl-2">  <Link to="/dustbin" className="site-nav lvl-2" > Bath Accessories </Link> </li>
                           <li className="lvl-2">  <Link to="/dustbin" className="site-nav lvl-2" > Pouffe </Link> </li>
                          </ul>
                      </div>
                      <div className="col-md-3"> 
                         <ul className="subLinks" style={{ marginTop:"5px"}}>
                          <li className="lvl-2">  <Link to="/dustbin" className="site-nav lvl-2" >  Tissue Box </Link> </li>
                           <li className="lvl-2">  <Link to="/dustbin" className="site-nav lvl-2" > Service Trolley </Link> </li>
                           <li className="lvl-2">  <Link to="/dustbin" className="site-nav lvl-2" > Apron</Link> </li>
                            <li className="lvl-2">  <Link to="/dustbin" className="site-nav lvl-2" > Washing Machine Cover </Link> </li>
                            <li className="lvl-2">  <Link to="/dustbin" className="site-nav lvl-2" > Dish Mat </Link> </li>
                          </ul>
                      </div>
                      <div className="col-md-3"> 
                         <ul className="subLinks" style={{ marginTop:"5px"}}>
                          <li className="lvl-2">  <Link to="/dustbin" className="site-nav lvl-2" >  Fridge Top </Link> </li>
                            <li className="lvl-2">  <Link to="/dustbin" className="site-nav lvl-2" > AC Curtain </Link> </li>
                            <li className="lvl-2">  <Link to="/dustbin" className="site-nav lvl-2" > Bed Server </Link> </li>
                           <li className="lvl-2">  <Link to="/dustbin" className="site-nav lvl-2" >  Shelf Liner </Link> </li>
                             <li className="lvl-2">  <Link to="/dustbin" className="site-nav lvl-2" > Napkin</Link> </li>
                          </ul>
                      </div>
                       <div className="col-md-3"> 
                         <ul className="subLinks" style={{ marginTop:"5px"}}>
                          <li className="lvl-2">  <Link to="/dustbin" className="site-nav lvl-2" > Glove </Link> </li>
                          <li className="lvl-2">  <Link to="/dustbin" className="site-nav lvl-2" > Coaster </Link> </li>
                          <li className="lvl-2">  <Link to="/dustbin" className="site-nav lvl-2" > Oven Top </Link> </li>
                          </ul>
                      </div>
                      <div className="col-md-3"> 
                         <Link to="/productList">
                           <img src={Homeaccessories001} alt="megamenu banner" style={{ marginTop: "2px", border:"1px solid #c1bfbfff", padding:"2px"}} />
                         </Link> 
                      </div>
                    </div>
                  </li>
                </ul>
              </nav>
              {/*End Desktop Menu*/}
            </div>
            <div className="col-4 col-sm-4 col-md-4 col-lg-2 align-self-center icons-col text-right">
              {/*Search*/}
              {/* <div className="site-search iconset">
                <i className="icon anm bi bi-search" />
              </div> */}
              {/*End Setting Dropdown*/}
              {/*Wishlist*/}
              <div className="wishlist-link iconset">
                <i className="icon anm bi bi-heart" />
                <span className="wishlist-count">0</span>
              </div>
              {/*End Wishlist*/}
              {/*Minicart Dropdown*/}
              <div className="wishlist-link iconset">
                <Link
                  href="/checkout/cart"
                  className="site-header__cart btn-minicart"
                  data-toggle="modal"
                  data-target="#minicart-drawer"
                 >
                  <i className="icon anm bi bi-bag" />
                  <span className="site-cart-count">2</span>
                </Link>
              </div>
              {/*End Minicart Dropdown*/}
              <div ref={dropdownRef} style={{ position:"relative", display:"inline-block" }} className="profiles-Account">
                  <Button onClick={handleToggle} style={{ padding:"0px 0px 0 7px", cursor:"pointer", border:"none", background:"none", fontSize:"18px" }}>
                    <i className="bi bi-person-circle"></i> <span style={{ fontSize:"13px" }}> Dileep </span>
                  </Button>
                    {isOpen && (
                      <ul
                        style={{
                          position: "absolute",
                          top: "100%",
                          left: "-40px",
                          backgroundColor: "#fff",
                          border: "1px solid #ccc",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                          listStyle: "none",
                          padding: "8px 0",
                          margin: 0,
                          width: "130px",
                          zIndex: 100,
                          textAlign:"left",
                          fontSize:"13px",
                        }}
                      >
                      <li style={{ padding: "4px 8px", cursor: "pointer", borderBottom:"1px solid rgb(202 195 195)" }}> <Link to="#">  <i className="bi bi-box-arrow-in-left"></i> Sign in </Link> </li>
                      <li style={{ padding: "4px 8px", cursor: "pointer", borderBottom:"1px solid rgb(202 195 195)" }}> <Link to="#"> <i className="bi bi-person-circle"></i> My Profile </Link>  </li>
                      <li style={{ padding: "4px 8px", cursor: "pointer" }}> <Link to="#"> <i className="bi bi-box-arrow-right"></i> Logout  </Link></li>
                    </ul>
                     )}
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}
export default Navigation;
